import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { AccessErrorState } from ".";

export const useAccessErrorReducer = () => {
	const returnSelector = useSelector((state: ApplicationState) => state.accessError);
	return returnSelector as AccessErrorState;
};
